import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-futon-bad',
    templateUrl: './futon-bad.component.html',
    providers: [MessageService, ConfirmationService],
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
    `],
    standalone: false
})
export class FutonBadComponent implements OnInit {

    @Input() housekeepingReport: any;

    constructor(
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) data: any) {
    }

    ngOnInit(): void {
    }

    get totalPickUp(): number {
        return (this.housekeepingReport?.futonSummaries || [])
            .filter((f: any) => f.isCheckout)
            .reduce((sum: number, f: any) => sum + (f.qty || 0), 0);
    }

    get totalDropOff(): number {
        return (this.housekeepingReport?.futonSummaries || [])
            .filter((f: any) => f.isCheckin)
            .reduce((sum: number, f: any) => sum + (f.qty || 0), 0);
    }

    get totalOccupied(): number {
        return (this.housekeepingReport?.futonSummaries || [])
            .filter((f: any) => f.isOccupied)
            .reduce((sum: number, f: any) => sum + (f.qty || 0), 0);
    }
}
